<ng-container *ngIf="ticketType && ticketType.id === 1">
  <span title="Подключение" class="cur-help">
    <app-icon [glyph]="'connect'" [size]="'20'" [color]="'yellow'"></app-icon>
  </span>
</ng-container>
<ng-container *ngIf="ticketType && ticketType.id === 2">
  <span title="Дозаказ" class="cur-help">
    <app-icon [glyph]="'circle-add'" [size]="'20'" [color]="'green-dark'"></app-icon>
  </span>
</ng-container>
<ng-container *ngIf="ticketType && ticketType.id === 3">
  <span title="Локальная заявка" class="cur-help">
    <app-icon [glyph]="'wrench'" [size]="'20'" [color]="'gray-dark'"></app-icon>
  </span>
</ng-container>
<ng-container *ngIf="ticketType && ticketType.id === 4">
  <span title="Глобальная проблема" class="cur-help">
    <app-icon [glyph]="'triangle-warning'" [size]="'20'" [color]="'red-dark'"></app-icon>
  </span>
</ng-container>
<ng-container *ngIf="ticketType && ticketType.id === 5">
  <span title="Исправление договора" class="cur-help">
    <app-icon [glyph]="'doc'" [size]="'20'" [color]="'gray-dark'"></app-icon>
  </span>
</ng-container>

<app-icon *ngIf="isGigabyte" [glyph]="'giga'" [size]="'20'"></app-icon>
